module.exports = __webpack_public_path__ + "img/checkbox.d2ba4908.svg";